// We want to ensure that only videos in these languages show if you're viewing the site in these languages. For example,
// if you're on the French site you should only ever see French recap and condensed games. If they aren't present, then
// they shouldn't show. However, if you're on the Spanish site, you should see the Spanish video if it's available, or the
// English one if not.
import { useMemo } from 'react';

import { useIntl } from 'react-intl';

import { ShortCodeEnums } from '@nhl/nhl-breakaway-ui';

const FORCE_VIDEO_LANGUAGE_LOCALES = [ShortCodeEnums.Language.English, ShortCodeEnums.Language.French];

export const useShouldForceVideoLanguage = (): boolean => {
    const intl = useIntl();

    return useMemo<boolean>(
        () => FORCE_VIDEO_LANGUAGE_LOCALES.includes(intl.locale as ShortCodeEnums.Language),
        [intl.locale]
    );
};
